import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, LinearProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { CompanyServices, IListCompany } from '../../services/api/company/CompanyServices';

interface VSelectCompanyProps {
    handleChangeSelect: (event: SelectChangeEvent) => void;
    initValue?: string;
    required?: boolean; 
}

export const VSelectCompany = ({ handleChangeSelect, initValue, required }: VSelectCompanyProps) => {
    const [value, setValue] = useState<string>(initValue || '');
    const [data, setData] = useState<IListCompany[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (initValue) {
            setValue(initValue);
        }
        fetchData();
    }, [initValue]);

    const fetchData = () => {
        setIsLoading(true);
        CompanyServices.get()
            .then((response) => {
                if (response instanceof Error) {
                    setData([]);
                } else {
                    const filteredData = response.filter(company => company.status === true);
                    setData(filteredData);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleSelectChange = (event: SelectChangeEvent) => {
        const newValue = event.target.value as string;
        setValue(newValue);
        handleChangeSelect(event);
    };

    if (isLoading) {
        return <LinearProgress />;
    }

    if (data.length === 0 && !isLoading) {
        return <p>Nenhuma empresa ativa encontrada.</p>;
    }


    const labelText = required ? 'Empresa *' : 'Empresa';

    return (
        <FormControl fullWidth>
            <InputLabel id="select_company">{labelText}</InputLabel>
            <Select
                labelId="select_company"
                id="select_company"
                value={value}
                label={labelText}
                onChange={handleSelectChange}
            >
                {data.map((item) => (
                    <MenuItem key={item.uuid} value={item.uuid}>
                        {item.nome}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};